import React, { useState, useEffect } from "react";
import { useParams, Link, useNavigate } from "react-router-dom";
import axios from "axios";
import { toast } from "react-toastify";
import { PulseLoader } from "react-spinners";

const API_URL = process.env.REACT_APP_API_URL;

const UserView = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [user, setUser] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    fetchUser();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  const fetchUser = async () => {
    if (!id) {
      toast.error("User ID is missing", { autoClose: 2000 });
      navigate("/user");
      return;
    }

    setIsLoading(true);
    try {
      const payload = {
        action: "get-user",
        id: id,
      };

      const response = await axios.post(API_URL, payload);

      // Parse the response - handle both string and object responses
      let responseData = response.data;
      if (typeof responseData === "string") {
        try {
          responseData = JSON.parse(responseData);
        } catch (parseError) {
          responseData = response.data;
        }
      }

      if (responseData.success === true && responseData.user) {
        setUser(responseData.user);
      } else {
        toast.error(responseData.message || "Failed to fetch user details", {
          autoClose: 2000,
        });
        navigate("/user");
      }
    } catch (error) {
      console.error("Fetch user error:", error);
      if (error.response && error.response.data) {
        let errorData = error.response.data;
        if (typeof errorData === "string") {
          try {
            errorData = JSON.parse(errorData);
          } catch (e) {
            // Use error message as is
          }
        }
        toast.error(
          errorData.message || "An error occurred while fetching user details",
          { autoClose: 2000 },
        );
      } else {
        toast.error(
          "Network error. Please check your connection and try again.",
          { autoClose: 2000 },
        );
      }
      navigate("/user");
    } finally {
      setIsLoading(false);
    }
  };

  // Capitalize first letter
  const capitalize = (str) => {
    if (!str) return "-";
    return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
  };

  // Format date to IST with AM/PM
  const formatDateToIST = (dateString) => {
    if (!dateString) return "-";
    const date = new Date(dateString);
    // Format with AM/PM in IST timezone
    return date.toLocaleString("en-US", {
      timeZone: "Asia/Kolkata",
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
      hour12: true,
    });
  };

  if (isLoading) {
    return (
      <div>
        <div className="content-header">
          <div className="container-fluid">
            <div className="row mb-2 align-items-center">
              <div className="col-6 col-sm-6">
                <h1 className="m-0 txt_lft">View User</h1>
              </div>
              <div className="col-6 col-sm-6">
                <ol className="breadcrumb justify-content-end">
                  <li className="breadcrumb-item">
                    <Link to="/user">
                      <i className="fa-solid fa-arrow-left-long" /> Back
                    </Link>
                  </li>
                </ol>
              </div>
            </div>
          </div>
        </div>
        <div className="content">
          <div className="container-fluid">
            <div className="row">
              <div className="frmwdth_cntr">
                <div className="col-lg-12">
                  <div className="card card-primary card-outline">
                    <div className="card-body text-center py-5">
                      <PulseLoader color="#1199B2" size={10} />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  if (!user) {
    return (
      <div>
        <div className="content-header">
          <div className="container-fluid">
            <div className="row mb-2 align-items-center">
              <div className="col-6 col-sm-6">
                <h1 className="m-0 txt_lft">View User</h1>
              </div>
              <div className="col-6 col-sm-6">
                <ol className="breadcrumb justify-content-end">
                  <li className="breadcrumb-item">
                    <Link to="/user">
                      <i className="fa-solid fa-arrow-left-long" /> Back
                    </Link>
                  </li>
                </ol>
              </div>
            </div>
          </div>
        </div>
        <div className="content">
          <div className="container-fluid">
            <div className="row">
              <div className="frmwdth_cntr">
                <div className="col-lg-12">
                  <div className="card card-primary card-outline">
                    <div className="card-body text-center py-5">
                      <p>User not found</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div>
      <div className="content-header">
        <div className="container-fluid">
          <div className="row mb-2 align-items-center">
            <div className="col-6 col-sm-6">
              <h1 className="m-0 txt_lft">View User</h1>
            </div>
            <div className="col-6 col-sm-6">
              <ol className="breadcrumb justify-content-end">
                <li className="breadcrumb-item">
                  <Link to="/user">
                    <i className="fa-solid fa-arrow-left-long" /> Back
                  </Link>
                </li>
              </ol>
            </div>
          </div>
        </div>
      </div>
      <div className="content">
        <div className="container-fluid">
          <div className="row">
            <div className="frmwdth_cntr">
              <div className="col-lg-12">
                <div className="card card-primary card-outline">
                  <form className="form-horizontal">
                    <div className="card-body">
                      <div className="form-group row align-items-center">
                        <label className="col-12 col-md-4 col-form-label">
                          Name
                        </label>
                        <div className="col-12 col-md-8">
                          <div className="txtdsply">{user.name || "-"}</div>
                        </div>
                      </div>
                      <div className="form-group row align-items-center">
                        <label className="col-12 col-md-4 col-form-label">
                          Email
                        </label>
                        <div className="col-12 col-md-8">
                          <div className="txtdsply">{user.email || "-"}</div>
                        </div>
                      </div>
                      <div className="form-group row align-items-center">
                        <label className="col-12 col-md-4 col-form-label">
                          Phone
                        </label>
                        <div className="col-12 col-md-8">
                          <div className="txtdsply">
                            {user.phoneNumber || "-"}
                          </div>
                        </div>
                      </div>
                      <div className="form-group row align-items-center">
                        <label className="col-12 col-md-4 col-form-label">
                          Business Name
                        </label>
                        <div className="col-12 col-md-8">
                          <div className="txtdsply">
                            {user.businessName || "-"}
                          </div>
                        </div>
                      </div>
                      {String(user.role || "").toLowerCase() === "supplier" && (
                        <div className="form-group row align-items-center">
                          <label className="col-12 col-md-4 col-form-label">
                            Supplier Name
                          </label>

                          <div className="col-12 col-md-8">
                            <div className="txtdsply">
                              {user.supplierName || "-"}
                            </div>
                          </div>
                        </div>
                      )}
                      {String(user.role || "").toLowerCase() === "customer" && (
                        <div className="form-group row align-items-center">
                          <label className="col-12 col-md-4 col-form-label">
                            Customer Name
                          </label>

                          <div className="col-12 col-md-8">
                            <div className="txtdsply">
                              {user.customerName || "-"}
                            </div>
                          </div>
                        </div>
                      )}
                      <div className="form-group row align-items-center">
                        <label className="col-12 col-md-4 col-form-label">
                          Role
                        </label>
                        <div className="col-12 col-md-8">
                          <div className="txtdsply">
                            {capitalize(user.role) || "-"}
                          </div>
                        </div>
                      </div>
                      <div className="form-group row align-items-center">
                        <label className="col-12 col-md-4 col-form-label">
                          Status
                        </label>
                        <div className="col-12 col-md-8">
                          <div className="txtdsply">
                            <span
                              className={`fwt_600 ${user.status === "active" ? "f_green" : "f_red"}`}
                              style={{ fontSize: "90%", fontWeight: 550 }}
                            >
                              {capitalize(user.status)}
                            </span>
                          </div>
                        </div>
                      </div>
                      <div className="form-group row align-items-center">
                        <label className="col-12 col-md-4 col-form-label">
                          Created At
                        </label>
                        <div className="col-12 col-md-8">
                          <div className="txtdsply">
                            {formatDateToIST(user.createdAt)}
                          </div>
                        </div>
                      </div>
                      <div className="form-group row align-items-center">
                        <label className="col-12 col-md-4 col-form-label">
                          Updated By
                        </label>
                        <div className="col-12 col-md-8">
                          <div className="txtdsply">
                            {user.updatedBy ||
                              (user.updatedById && user.updatedById.name) ||
                              "-"}
                          </div>
                        </div>
                      </div>
                      <div className="form-group row align-items-center">
                        <label className="col-12 col-md-4 col-form-label">
                          Updated At
                        </label>
                        <div className="col-12 col-md-8">
                          <div className="txtdsply">
                            {formatDateToIST(user.updatedAt)}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="card-footer text-center">
                      <Link
                        to={`/userEdit/${user.id}`}
                        className="btn btn-blue mr-2"
                      >
                        Edit
                      </Link>
                      {/* <Link to="/user" className="btn btn-secondary">Cancel</Link> */}
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UserView;
